import React, {useContext} from 'react';
import itLocale from "date-fns/locale/it";
import enLocale from "date-fns/locale/en-US";
import {Controller} from "react-hook-form";
import {KeyboardDatePickerCompat} from "./KeyboardDatePickerCompat";
import {getHelperStyle} from "../../../styles/components/FormStyle";
import EventTwoToneIcon from '@mui/icons-material/EventTwoTone';
import Tooltip from "@mui/material/Tooltip";
import {FormControl, FormHelperText} from "@mui/material";
import {isEmpty} from "../../../utils/GenericUtils";
import {AppContext} from "../../../App";
import {languages} from "../../../strings/LanguageDictionary";


const CustomDateInput = ({name, label, control, defaultValue, maxDate, minDate, disabled, rules = {}, error, size = "medium"}) => {
	const appContext = useContext(AppContext);

	return (
		<React.Fragment>
			<FormControl error={!isEmpty(error)} size={size} style={{width: "100%"}}
			             variant={"outlined"}>
					<Controller
						render={({onChange, value}) => (
							<KeyboardDatePickerCompat
								value={value}
								locale={appContext.state.lang === "it" ? itLocale : enLocale}
								margin='dense'
								keyboardIcon={<Tooltip
									title={languages[appContext.state.lang].OCEAN__GLOBAL_SELECT_DATE_INP}><EventTwoToneIcon/></Tooltip>}
								onChange={onChange}
								disabled={disabled}
								style={{width: "100%"}}
								label={label}
								size={size}
								inputVariant="outlined"
								maxDate={maxDate ? maxDate : new Date(2100, 1, 1, 1, 1, 1, 1)}
								minDate={minDate ? minDate : new Date(1900, 1, 1, 1, 1, 1, 1)}
								invalidDateMessage={<span
									style={getHelperStyle().helperDate}>{languages[appContext.state.lang].OCEAN__GLOBAL_SELECT_DATE_ERR}</span>}
								maxDateMessage={<span
									style={getHelperStyle().helperDate}>{languages[appContext.state.lang].OCEAN__GLOBAL_SELECT_DATE_MAX}</span>}
								minDateMessage={<span
									style={getHelperStyle().helperDate}>{languages[appContext.state.lang].OCEAN__GLOBAL_SELECT_DATE_MIN}</span>}
								format="dd/MM/yyyy"
								showTodayButton={true}
								todayLabel={languages[appContext.state.lang].OCEAN__GLOBAL_SELECT_DATE_TOD}
								cancelLabel={languages[appContext.state.lang].OCEAN__GLOBAL_SELECT_DATE_CAN}
								clearable={false}
							/>
						)}
						name={name}
						control={control}
						defaultValue={defaultValue}
						rules={rules}
					/>
				{!isEmpty(error) && <FormHelperText
					style={getHelperStyle().helper}>{languages[appContext.state.lang].OCEAN__GLOBAL_REQUIRED_FILES_}</FormHelperText>
				}
			</FormControl>
		</React.Fragment>
	);
}

export default React.memo(CustomDateInput);
